import { create } from "zustand";

export const DeleteEducationProgramWeekly = create((set) => ({
  deleted: false,

  setDelete: (status: boolean) => set(() => ({ deleted: status })),
}));
